import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { isProduction } from "../../utils/environment.js";
import styled from "styled-components";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem;
  height: 100%;
  width: 100%;
`;
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 1.5rem;
  color: ${(props) => props.theme.cell.warning.color};
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  max-width: 400px;
`;
const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  color: ${(props) => props.theme.cell.color};
`;
const Subtitle = styled.p`
  font-size: 13px;
  color: ${(props) => props.theme.cell.secondaryColor};
  margin: 0;
  line-height: 1.5;
`;
const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
`;
const Button = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 4px;
  background-color: ${(props) => props.theme.cell.color};
  color: ${(props) => props.theme.backgroundColor};
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.9;
  }
`;
const ErrorStack = styled.pre`
  margin-top: 2rem;
  padding: 1rem;
  background-color: ${(props) => props.theme.cell.warning.backgroundColor};
  border: 1px solid ${(props) => props.theme.cell.warning.borderColor};
  border-radius: 4px;
  color: ${(props) => props.theme.cell.warning.color};
  font-size: 0.875rem;
  overflow: auto;
  max-width: 100%;
  max-height: 200px;
`;
const TriangleExclamation = () => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ jsx("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
      /* @__PURE__ */ jsx("line", { x1: "12", y1: "9", x2: "12", y2: "13" }),
      /* @__PURE__ */ jsx("line", { x1: "12", y1: "17", x2: "12.01", y2: "17" })
    ]
  }
);
const ErrorFallback = ({ error }) => {
  const { t } = useTranslation();
  if (error) {
    console.error(error.stack);
  }
  const onClickRefresh = () => {
    window == null ? void 0 : window.location.reload();
  };
  return /* @__PURE__ */ jsxs(Container, { role: "alert", children: [
    /* @__PURE__ */ jsx(IconWrapper, { children: /* @__PURE__ */ jsx(TriangleExclamation, {}) }),
    /* @__PURE__ */ jsxs(ContentWrapper, { children: [
      /* @__PURE__ */ jsx(Title, { children: t("errors.unknownError", "An error has occurred") }),
      /* @__PURE__ */ jsx(Subtitle, { children: t("errors.refreshPageDescription", "Please try refreshing the page") }),
      /* @__PURE__ */ jsx(ButtonGroup, { children: /* @__PURE__ */ jsx(
        Button,
        {
          onClick: onClickRefresh,
          "data-testid": "error-state-refresh-button",
          children: t("errors.refreshButton", "Refresh Page")
        }
      ) })
    ] }),
    !isProduction && (error == null ? void 0 : error.stack) && /* @__PURE__ */ jsx(ErrorStack, { children: error.stack })
  ] });
};
export {
  ErrorFallback
};
